import config from "src/config";
import { ResponseDto } from 'src/dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from 'src/utils/axios/serverHelper';
import { MST4010_R01Dto } from './Dto_MST4010_R01';
import { MST4010_R01Filter } from "./Store_MST4010_R01";

const baseUrl = `${config.apiUrl}/MST4010_R01`;

export const getMST4010_R01List = async (option: string, params: Partial<MST4010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`

	return await getData<ResponseDto<MST4010_R01Dto[]>>(url, {
		params: {
			...params,
			listLength
		}
	});
}

export const getMST4010_R01AllCount = async (params: Partial<MST4010_R01Filter>) => {
	const url = `${baseUrl}/allCount`;

	return await getData<ResponseDto<number>>(url, {
		params: {
			...params
		}
	});
}

export const getMST4010_R01One = async (equipmentCd: string) => {
	const url = `${baseUrl}/one/${equipmentCd}`;
	
	return await getData<ResponseDto<MST4010_R01Dto>>(url);
}

export const getMST4010_R01Image = async (equipmentCd: string) => {
	const url = `${baseUrl}/image/${equipmentCd}`;

	return await getData<ResponseDto<MST4010_R01Dto>>(url);
}

export const createMST4010_R01 = async (data: MST4010_R01Dto) => {
	return await postData<MST4010_R01Dto, ResponseDto<MST4010_R01Dto[]>>(baseUrl, data);
}

export const patchMST4010_R01 = async (data: MST4010_R01Dto) => {
	return await patchData<MST4010_R01Dto, ResponseDto<MST4010_R01Dto[]>>(baseUrl, data);
}

export const deleteMST4010_R01 = async (equipmentCd: string) => {

	return await deleteData<ResponseDto<any>>(baseUrl, {
		params: {
			primary: equipmentCd
		}
	})
}

export const downloadExcel_MST4010_R01 = async (option: string, params: Partial<MST4010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`;

	return await getData<ResponseDto<string>>(url, {
		params: {
			...params,
			listLength
		}
	});
}